import './chat.css';
import { Component, h, state, css, page, signal, Fragment } from 'pylevate-runtime';
import { getMe } from '../api.js';
import { Nav } from '../components/nav.js';
import { ChatApp } from '../ui/app.js';
export class Chat extends Component {
  constructor(...args) {
    super(...args);
    this._email = signal('');
    this._ws_state = signal('');
    this._ready = signal(false);
  }
  get email() { return this._email.value; }
  set email(v) { this._email.value = v; }
  get ws_state() { return this._ws_state.value; }
  set ws_state(v) { this._ws_state.value = v; }
  get ready() { return this._ready.value; }
  set ready(v) { this._ready.value = v; }
  async componentDidMount() {
    let me = await getMe();
    if (!__truthy(me['signed_in'])) {
      window.location.href = '/api/auth/login?next=' + encodeURIComponent(location.pathname);
      return;
    }
    this._email.value = me['account']['email'];
    this._ready.value = true;
  }
  set_ws(s) {
    this._ws_state.value = s;
  }
  render(props, state, context) {
    const children = props && props.children;
    return h('div', {className: 'page-b12229'}, h(Fragment, null, h(Nav, {email: this._email.value, ws_state: this._ws_state.value}), (this._ready.value ? h(ChatApp, {pid: this.props.id, onWsState: (s) => this.set_ws(s)}) : null)));
  }
}
Chat = page({title: 'Uplevate', route: '/p/:id'})(Chat);
